import { mapSelectedProductTypeToTabId, type TCreditPurposeFormData } from 'entities/creditForm';

import { getProductTypeTabById } from './getProductTypeTabById';

export const resolveActiveProductTypeTabId = (
  creditPurposeData: Pick<TCreditPurposeFormData, 'selectedProductType' | 'purpose'>,
) =>
  mapSelectedProductTypeToTabId({
    selectedProductType: creditPurposeData.selectedProductType,
    purpose: creditPurposeData.purpose?.value,
  });

export const resolveActiveProductTypeTabTitle = (
  creditPurposeData: Pick<TCreditPurposeFormData, 'selectedProductType' | 'purpose'>,
) => getProductTypeTabById(resolveActiveProductTypeTabId(creditPurposeData)).title;
